module.exports = __webpack_public_path__ + "img/proyecto_2.0660df13.png";